const state = {
  campusList: [],
  canteenList: [],
  windowList: [],
  dishList: [],
  loading: false
}

const mutations = {
  SET_CAMPUS_LIST(state, campuses) {
    state.campusList = campuses
  },
  SET_CANTEEN_LIST(state, canteens) {
    state.canteenList = canteens
  },
  SET_WINDOW_LIST(state, windows) {
    state.windowList = windows
  },
  SET_DISH_LIST(state, dishes) {
    state.dishList = dishes
  },
  SET_LOADING(state, status) {
    state.loading = status
  }
}

const actions = {
  // 食堂管理相关操作将在后续实现
}

const getters = {
  campusList: state => state.campusList,
  canteenList: state => state.canteenList,
  windowList: state => state.windowList,
  dishList: state => state.dishList,
  loading: state => state.loading
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
